export default __webpack_public_path__ + "static/media/01.e1b83ccb.jpg";